import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';
import { resolveLandingPreset } from '../hooks/useCandidaturaDraft';
import { trackPartnerEvent } from '../hooks/useCandidaturaAnalytics';
import heroCandidatura from '../assets/heroCandidatura.webp';
import logo from '../assets/logo.png';

export default function CandidaturaLanding() {
  const { slug } = useParams();
  const preset = resolveLandingPreset(slug);

  if (!preset) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFFEFA] px-4">
        <p className="text-gray-600 mb-4">Pagina non trovata.</p>
        <Link to="/diventa-partner" className="text-[#c78244] underline">Vai all&apos;hub partner</Link>
      </div>
    );
  }

  const candidaturaUrl = `/candidatura?landing=${slug}&categoria=${encodeURIComponent(preset.categoria)}&ruolo=${preset.ruolo}`;

  return (
    <div className="min-h-screen bg-[#FFFEFA]">
      <div className="relative h-64 sm:h-80">
        <img src={heroCandidatura} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-4 text-center">
          <img src={logo} alt="Mangitalia" className="w-16 h-16 mb-3 rounded-full bg-white/90 p-1" />
          <h1 className="text-2xl sm:text-4xl font-bold">{preset.titolo}</h1>
          <p className="mt-2 max-w-lg opacity-90">{preset.sottotitolo}</p>
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-xl mx-auto px-4 py-10 text-center"
      >
        <ul className="text-left text-gray-600 space-y-3 mb-8 text-sm">
          <li className="flex gap-2"><span className="text-[#F6CF48]">✓</span> Candidatura gratuita, senza commissioni</li>
          <li className="flex gap-2"><span className="text-[#F6CF48]">✓</span> Bozza in 2 minuti con codice accesso via email</li>
          <li className="flex gap-2"><span className="text-[#F6CF48]">✓</span> Valutazione qualità e visibilità nel catalogo curato</li>
          <li className="flex gap-2"><span className="text-[#F6CF48]">✓</span> Pagamento alla consegna, modello pull anti-sprechi</li>
        </ul>

        <Link
          to={candidaturaUrl}
          onClick={() => trackPartnerEvent('partner_cta_click', { source: 'landing', landing: slug })}
          className="inline-block bg-gradient-to-r from-[#F6CF48] to-[#c78244] text-white px-10 py-4 rounded-full font-bold text-lg shadow-xl"
        >
          Candidati ora
        </Link>
        <p className="mt-4 text-sm text-gray-500">
          <Link to="/diventa-partner" className="text-[#c78244] underline">Scopri tutti i percorsi partner</Link>
        </p>
      </motion.div>
    </div>
  );
}
